import styled from "styled-components";

export const StyledInputPrefix = styled.div`
    .Polaris-TextField__Prefix {
        order: 2;
    }

    .Polaris-TextField__Input {
        order: 1;
        padding: 0 12px;
    }

    .Polaris-TextField__Spinner {
        order: 3
    }
`